import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {Card} from '../card/card';
import {colors} from '../colors/colors';
import {ErrorCircleIcon, WarningIcon, HtmlLinkIcon} from '../icon';

import styles from './list-sequence-row-body.module.css';

type Props = {
    title: string | React.ReactElement<any>;
    subtitle: string | React.ReactElement<any>;
    isSelected: boolean;
    onClick: () => void;
    errorMessage?: string | null | undefined;
    warningMessage?: string | null | undefined;
    linkCount?: number;
    shouldShowCounts?: boolean;
    includeReactTooltipComponent?: boolean;
};

export class ListSequenceRowBody extends React.PureComponent<Props> {
    static defaultProps = {
        includeReactTooltipComponent: true,
    };

    componentDidMount() {
        ReactTooltip.rebuild();
    }

    componentDidUpdate(prevProps: Props) {
        if (
            prevProps.errorMessage !== this.props.errorMessage ||
            prevProps.warningMessage !== this.props.warningMessage
        ) {
            ReactTooltip.rebuild();
        }
    }

    render() {
        const {title, subtitle, isSelected, onClick, errorMessage, warningMessage} = this.props;
        let borderColor: string = colors.offWhiteDk;
        if (warningMessage) borderColor = colors.yellow;
        if (errorMessage) borderColor = colors.rose;
        if (isSelected) borderColor = colors.blue;

        return (
            <div className={styles['card-container']}>
                {this.props.includeReactTooltipComponent ? (
                    <ReactTooltip delayShow={300} className='react-tooltip' effect='solid' />
                ) : undefined}
                <Card
                    hasBorder={true}
                    hasShadow={true}
                    borderColor={borderColor}
                    className={styles.card}
                >
                    <div onClick={onClick} className={styles['row-text']}>
                        <div className={styles['title-container']}>
                            {/* Add a nonbreaking space to maintain vertical spacing */}
                            <div className={styles.title}>{title || <span>&nbsp;</span>}</div>
                            <div className={styles['trouble-icons']}>
                                {errorMessage ? (
                                    <ErrorCircleIcon
                                        data-tip={errorMessage}
                                        className={styles['error-icon']}
                                    />
                                ) : null}
                                {warningMessage ? (
                                    <WarningIcon
                                        // @ts-expect-error
                                        color={colors.yellow}
                                        size={15}
                                        data-tip={warningMessage}
                                    />
                                ) : null}
                            </div>
                        </div>
                        <div className={styles['subtitle-container']}>
                            <div className={styles.subtitle}>{subtitle || <span>&nbsp;</span>}</div>
                            {typeof this.props.linkCount !== 'undefined' &&
                            this.props.shouldShowCounts ? (
                                <div
                                    data-tip={
                                        this.props.linkCount === 0
                                            ? 'This email doesn’t contain any tracked links.'
                                            : `This email contains ${
                                                  this.props.linkCount || 0
                                              } tracked ${
                                                  this.props.linkCount === 1 ? 'link' : 'links'
                                              }.`
                                    }
                                    className={styles['tracked-links-count']}
                                >
                                    <HtmlLinkIcon wrapWithDiv={false} size={13} />{' '}
                                    {this.props.linkCount}
                                </div>
                            ) : undefined}
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}
